import { createFileRoute, redirect } from '@tanstack/react-router'
import { ROUTES, hasAdminOrAvaliadorAccess, isBcOnlyUser } from '@/lib/route-guards'

export const Route = createFileRoute('/_authenticated/')({
  beforeLoad: async () => {
    const bcOnly = await isBcOnlyUser()
    if (bcOnly) {
      throw redirect({ to: ROUTES.BC_DEFAULT, replace: true })
    }

    const adminAccess = await hasAdminOrAvaliadorAccess()
    throw redirect({
      to: adminAccess ? ROUTES.ADMIN_DEFAULT : ROUTES.EMPLOYEE_DEFAULT,
      replace: true,
    })
  },
})
